import { render, staticRenderFns } from "./AuthorizedAcceptorAuthorize.vue?vue&type=template&id=32a489be"
import script from "./AuthorizedAcceptorAuthorize.vue?vue&type=script&lang=js"
export * from "./AuthorizedAcceptorAuthorize.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedAcceptorAuthorize.vue?vue&type=style&index=0&id=32a489be&prod&scopped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports